import React, { FunctionComponent } from 'react'

import { IProps } from './IProps'
import { FlexContainer } from './style'

export const Flex: FunctionComponent<IProps> = (props) => (
    <FlexContainer
        className={props.className}
        container={props.container}
        /****** Container Props ********/
        flexDirection={props.flexDirection}
        justifyContent={props.justifyContent}
        flexWrap={props.flexWrap}
        alignItems={props.alignItems}
        /****** Child Props ********/
        flexGrow={props.flexGrow}
        flexShrink={props.flexShrink}
        flexBasis={props.flexBasis}
        flex={props.flex}
        /****** Common Layout Props ********/
        padding={props.padding}
        margin={props.margin}
        width={props.width}
        height={props.height}
        maxWidth={props.maxWidth}
        maxHeight={props.maxHeight}
        minWidth={props.minWidth}
        minHeight={props.minHeight}
        bgColor={props.bgColor}
        /****** Break ********/
        breakBefore={props.breakBefore}
        breakAfter={props.breakAfter}
        style={props.style}
        onClick={props.onClick}
    >
        {props.children}
    </FlexContainer>
)
